module.exports = __webpack_public_path__ + "static/img/zanwuneirong.d7d439d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zanwuneirong.png
// module id = HteP
// module chunks = 1